import { defineKey as T } from '@ha/intl';

export const reportReasons = {
  attemptToPayOutside: {
    value: 'Attempt to pay or communicate outside Housing Anywhere',
    title: T('Attempt to pay or communicate outside Housing Anywhere'),
    hint: T(
      'The user tries to share an email address, phone number or website in the conversation or the profile.',
    ),
  },
  suspicionOfFraud: {
    value: 'Suspicion of fraud',
    title: T('Suspicion of fraud'),
    hint: T(
      'The profile belongs to a scammer, potential criminal or is used for other malicious purposes.',
    ),
  },
  discriminatory: {
    value: 'Discriminatory or hateful content',
    title: T('Discriminatory or hateful content'),
    hint: T(
      'The profile picture, description, or content shared in a conversation are considered inappropriate.',
    ),
  },
  other: {
    value: 'Other',
    title: T('Other'),
    hint: T('None of the above reasons apply.'),
  },
};
